import React from 'react';
import { Box } from '@mui/material';

/**
 * Reusable Component for Rendering HTML Content
 */
const HtmlContent = ({ html }) => {

    return (
        <Box
            sx={{
                color: '#555',
                lineHeight: 1.6,
                '& h1': { fontSize: '2em', fontWeight: 'bold', mt: 3, mb: 2 },
                '& h2': { fontSize: '1.5em', fontWeight: 'bold', mt: 3, mb: 2 },
                '& p': { mb: 2 },
                '& ul': { pl: 3, mb: 2 },
                '& ol': { pl: 3, mb: 2 },
                '& li': { marginBottom: '8px' },
                '& code': {
                    backgroundColor: '#f5f5f5',
                    borderRadius: '4px',
                    fontSize: '0.875em',
                    padding: '2px 4px',
                    display: 'inline-block'
                },
                '& pre': {
                    backgroundColor: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '4px',
                    overflowX: 'auto'
                },
                '& a': { color: '#1976d2', textDecoration: 'none' }
            }}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

export default HtmlContent;
